import { Component } from 'react';

import { RootState } from '@iwProvider/configureStore';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { FieldArray, formValueSelector } from 'redux-form';

import { getApplicationStatus } from '../../../../api/lendingAPI/ApplicationSelector';
import { FormField } from '../../../../forms/formField/index';
import { getCountry } from '../../../../iwIntlProvider/CountryProvider';
import { PlusSVG } from '../../../../svgComponents/plusSVG/index';
import { TrashcanSVG } from '../../../../svgComponents/trashcanSVG/index';
import styles from '../PersonModal.module.css';

const selector = formValueSelector('person');
const mapStateToProps = (state: RootState) => ({
    isEditingPerson: state.personModal.isEditingPerson,
    hasCreditDecision: getApplicationStatus(state) !== 'open',
    isGuarantor: selector(state, 'isGuarantor'),
    isApplicant: selector(state, 'isApplicant')
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

export class ContactDetails extends Component<PropsFromRedux> {
    buildPhoneNumberFields = ({ fields }: any) => {
        const personalDetailsEditingDisabled =
            this.props.hasCreditDecision &&
            this.props.isEditingPerson &&
            this.props.isGuarantor &&
            !this.props.isApplicant;

        return (
            <>
                {fields.map((phone: string, index: number) => (
                    <div key={index} className={styles.removeWrapper}>
                        {index === 0 ? (
                            <FormField
                                className="fs-exclude"
                                data-testid="phone-input"
                                key={index}
                                name={`${phone}.number`}
                                label={
                                    <FormattedMessage
                                        id="_.person.phone"
                                        defaultMessage="Phone number"
                                    />
                                }
                                disabled={personalDetailsEditingDisabled}
                            />
                        ) : (
                            <>
                                <FormField
                                    className="fs-exclude"
                                    data-testid="phone-input"
                                    key={index}
                                    name={`${phone}.number`}
                                    disabled={personalDetailsEditingDisabled}
                                />
                                {personalDetailsEditingDisabled ? null : (
                                    <div
                                        className={styles.removeBtn}
                                        onClick={() => fields.remove(index)}
                                        data-testid="remove-phone-number"
                                    >
                                        <TrashcanSVG />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                ))}
                {personalDetailsEditingDisabled ? null : (
                    <button
                        className={styles.addBtn}
                        type="button"
                        onClick={() => fields.push()}
                    >
                        <FormattedMessage
                            id="_.person.add_another_phone_number"
                            defaultMessage="Add another phone number"
                        />
                        <PlusSVG className={styles.addIcon} />
                    </button>
                )}
            </>
        );
    };

    renderContactDetailsSection = () => {
        const personalDetailsEditingDisabled =
            this.props.hasCreditDecision &&
            this.props.isEditingPerson &&
            this.props.isGuarantor;
        return (
            <>
                <div className={styles.subTitle}>
                    <FormattedMessage
                        id="_.person.contact_details"
                        defaultMessage="Contact details"
                    />
                </div>

                <FormField
                    className={classNames(styles.emailField, 'fs-exclude')}
                    data-testid="email-input"
                    name="email"
                    label={
                        <FormattedMessage
                            id="_.person.email"
                            defaultMessage="Email address"
                        />
                    }
                    disabled={personalDetailsEditingDisabled}
                />
                <FieldArray
                    name="phones"
                    component={this.buildPhoneNumberFields}
                />
            </>
        );
    };

    render() {
        const { isGuarantor } = this.props;
        const ContactDetailsSection = this.renderContactDetailsSection;

        if (getCountry() === 'DE') {
            return <ContactDetailsSection />;
        }

        return isGuarantor ? <ContactDetailsSection /> : null;
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ContactDetails);
